import React, { useEffect, useState } from 'react';
export const StickyBar = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-gold-dark via-gold to-gold-dark text-white py-1 px-4 text-center text-[11px] font-medium tracking-wide shadow-sm flex items-center justify-center gap-3" data-id="element-272">
      <span className="hidden sm:inline" data-id="element-273">OFERTA DE LANZAMIENTO · 40% OFF</span>
      <span className="sm:hidden" data-id="element-274">40% OFF · TIEMPO LIMITADO</span>
      <span className="bg-black/15 px-2 py-0.5 rounded-full text-[10px] font-bold tabular-nums" data-id="element-275">
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </span>
    </div>;
};